const getLanguageElements = () => {
    const isMobile = site.helpers.isMobileCheck();
    const container = isMobile
        ? document.getElementById("languageListContainerMobile")
        : document.getElementById("languageListContainer");

    if (!container) return {};

    return {
        container,
        toggleButton: container.querySelector("[data-toggle-languageList]"),
        list: container.querySelector("[data-type='languageList']"),
        chevron: container.querySelector("[data-chevron]"),
    };
};

const initToggleLanguage = () => {
    const { toggleButton } = getLanguageElements();
    if (!toggleButton) return;

    toggleButton.removeEventListener("click", toggleLanguageClickHandler);
    toggleButton.addEventListener("click", toggleLanguageClickHandler);

    document.removeEventListener("click", outsideClickListener);
    document.addEventListener("click", outsideClickListener);

    window.removeEventListener("blur", blurHandler);
    window.addEventListener("blur", blurHandler);
};

const toggleLanguageClickHandler = () => {
    const { toggleButton } = getLanguageElements();
    if (!toggleButton) return;

    const expanded = toggleButton.getAttribute("aria-expanded") === "true";

    if (expanded) {
        closeLanguageMenu();
    } else {
        const { list, chevron } = getLanguageElements();
        list.style.display = "block";
        chevron.style.transform = "rotate(180deg)";
        toggleButton.setAttribute("aria-expanded", "true");
    }
};

const outsideClickListener = (event) => {
    const { container, toggleButton } = getLanguageElements();
    if (!container || !toggleButton) return;

    const expanded = toggleButton.getAttribute("aria-expanded") === "true";
    if (!container.contains(event.target) && expanded) {
        closeLanguageMenu();
    }
};

const blurHandler = () => {
    const { toggleButton } = getLanguageElements();
    const expanded = toggleButton?.getAttribute("aria-expanded") === "true";
    if (expanded) {
        closeLanguageMenu();
    }
};

const closeLanguageMenu = () => {
    const { toggleButton, list, chevron } = getLanguageElements();
    if (!toggleButton || !list || !chevron) return;

    list.style.display = "none";
    chevron.style.transform = "rotate(0deg)";
    toggleButton.setAttribute("aria-expanded", "false");
};

// Close language selector if header is animating
const checkAndCloseLanguageList = () => {
    const { toggleButton } = getLanguageElements();
    if (toggleButton.getAttribute("aria-expanded") === "true") {
        toggleButton.click();
    }
};

// Close language selector if header is animating
const checkAndCloseMobileList = () => {
    const mobileButton = document.getElementById("toggleMobileMenuButton");
    if (mobileButton.getAttribute("aria-expanded") === "true") {
        mobileButton.click();
    }
};


// Function to update menu and header animation
const updateHeaderAndMenu = () => {
    const isMobile = site.helpers.isMobileCheck();
    const isTablet = site.helpers.isTabletCheck();

    const headerElement = document.getElementById("headerId");
    const content = document.getElementById("pageWrapper");
    let headerHeight = isMobile ? 80 : isTablet ? 96 : 128; // Default height of the header for Desktop & Mobile
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let timeoutId;

    // Call the resize check menu function
    checkForResizeMenu();
    initToggleLanguage();


    window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
            // Scrolling down and beyond header height
            headerElement.style.transition = "transform .3s ease .3s";
            headerElement.style.transform = "translateY(-100%)";
            headerElement.style.position = "fixed";
            content.style.paddingTop = `${headerHeight}px`;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                checkAndCloseLanguageList();
            }, 150);
            if (isMobile) {
                checkAndCloseMobileList();
            };
        } else if (scrollTop < lastScrollTop) {
            // Scrolling up
            headerElement.style.transition = "transform .4s ease-in-out .3s";
            headerElement.style.transform = "translateY(0)";
            if (scrollTop == 0 && isMobile) {
                headerElement.style.position = "";
                content.style.paddingTop = "0px";
                headerElement.style.transition = "";
                headerElement.style.transform = "";
            } else {
                headerElement.style.position = "fixed";
                content.style.paddingTop = `${headerHeight}px`;
            }
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    }, { passive: true });
};

// Function to update Menu padding
const menuPadding = () => {
    if (window.pageYOffset === 0) return;
    const isMobile = site.helpers.isMobileCheck();
    const isTablet = site.helpers.isTabletCheck();
    const content = document.getElementById("pageWrapper");

    let headerHeight = isMobile ? 80 : isTablet ? 96 : 128; // Default height of the header for Desktop & Mobile
    content.style.paddingTop = `${headerHeight}px`;
}

// Function to update Menu - {mobile} && {desktop}
const checkForResizeMenu = () => {
    menuPadding()

    //Selectors
    const mobileMenu = document.getElementById("mobileMenu");
    const toggleButton = document.getElementById("toggleMobileMenuButton");
    const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
    const desktopMenu = document.getElementById("desktopHeaderMenu");
    const desktopButtons = document.querySelectorAll("[data-name=header-button]");
    const mobileToggleLI = document.getElementById("mobileToggleListItem");

    //Checks
    const currentMobileHidden = isExpanded ? "false" : "true";
    const isMobile = site.helpers.isMobileCheck();

    //Attribute setters
    mobileToggleLI.setAttribute("aria-hidden", isMobile ? "false" : "true")
    mobileMenu.setAttribute("aria-hidden", !isMobile ? "true" : currentMobileHidden);
    desktopMenu.setAttribute("aria-hidden", isMobile ? "true" : "false");
    desktopButtons.forEach(button => {
        button.setAttribute("aria-hidden", isMobile ? "true" : "false");
    });
    if (isMobile && !isExpanded) {
        mobileMenu.setAttribute("inert", "");
    } else {
        mobileMenu.removeAttribute("inert");
    }
};


const header = {
    handleHeaderAnimation: () => {
        // Initial updates
        updateHeaderAndMenu();
        initToggleLanguage();

        // Update on window resize with a delay of .2s
        window.addEventListener("resize", site.helpers.debounce(updateHeaderAndMenu, 200));


    },
    initToggleMobileMenu: () => {
        const toggleButton = document.getElementById("toggleMobileMenuButton");
        const mobileMenu = document.getElementById("mobileMenu");
        const toggleHiddenDiv = document.getElementById("toggle-hidden-div");
        toggleButton.addEventListener("click", () => {
            // Triggers mobile button animation @tailwind.scss -> Utilities
            toggleButton.classList.toggle("open");
            const isExpanded = toggleButton.getAttribute("aria-expanded") === "false";
            toggleButton.setAttribute("aria-expanded", isExpanded ? "true" : "false");
            // Triggers mobile menu open animation @tailwind.scss -> Utilities
            mobileMenu.classList.toggle("open")

            mobileMenu.setAttribute("aria-hidden", isExpanded ? "false" : "true");
            if (!isExpanded) {
                mobileMenu.setAttribute("inert", "");
                toggleHiddenDiv.classList.add("overflow-hidden");
            } else {
                 toggleHiddenDiv.classList.remove("overflow-hidden");
                mobileMenu.removeAttribute("inert");
            }

        });
    },
    // Adds underline to the active item by checking the url path
     checkActiveItem = () => {
        const currentUrl = window.location.href.split('?')[0];
        const isMobile = site.helpers.isMobileCheck();
        
        const updateMenuLinks = (menuLinks) => {
            menuLinks.forEach(link => {
                const linkUrl = link.href.split('?')[0];

                if (linkUrl === currentUrl) {
                    link.style.textDecoration = "underline";
                } else {
                    link.style.textDecoration = "none";
                }
            });
        };

        if (isMobile) {
            const menuLinks = document.querySelectorAll("#mobileMenuList a");
            updateMenuLinks(menuLinks);
        } else {
            const menuLinks = document.querySelectorAll("#desktopHeaderMenu a");
            updateMenuLinks(menuLinks);
        }
    }

};

// Load Header
document.addEventListener('DOMContentLoaded', () => {
    header.handleHeaderAnimation();
    header.initToggleMobileMenu();
    header.checkActiveItem();
    window.addEventListener("resize", site.helpers.debounce(header.checkActiveItem, 200));
});
